<template lang="pug">
    ModelBasic(:show-left="showForm" :status="status" :error-info="errorInfo" @download="toDownloadPdf" :downloadShow='false' :downloadResource='false' :download="download" :rightTitle="$t('gzzoc.FundusImageQualitReportTitle')")
        template(slot="left-title")
            .form-title(:class="titleClass")
        template(slot="left-content")
            .form-container
                el-form.form(ref="form", :model="model", v-if="model && model.parameters")
                    el-form-item(
                        v-for="(item, index) in model.parameters",
                        :rules="rules[item.name]",
                        :key="`${item.name}_${item.key_type}`",
                        :prop="'parameters.' + index + '.value'")
                        .name {{item.display}}
                        GroupTitle(v-if="item.data_type === 'title'" :title="item.title" :tip="item.tip")
                        //input-radio
                        el-radio-group.item(
                            v-model="item.value",
                            v-else-if="item.ques_type === 'single_choice' && item.show_type === 'select'")
                            el-radio.gzzoc-radio(
                                v-for="(info, i) in item.options",
                                :key='i',
                                :label="info.value") {{info.show_name}}
                        //file
                        el-upload.gzzoc-upload.item(
                            v-model="item.value",
                            v-else-if="item.ques_type === 'file'",
                            action="/api/upl/s3/upload/big/file/unsafe",
                            :show-file-list="false",
                            :ref="item.name"
                            :before-upload="(file) => {return beforeImgUpload(file,item.name)}",
                            :on-success="(res,file,files) => {return uploadsucc(res,file,files,item.name)}",
                            :on-error="(res) => {return handleError(res, item.name)}",
                            :on-progress="() => {return handleProgress(item.name)}")
                            .file-content-wrapper
                                el-button.upload-button(type="primary" :loading="loadingUploadBtn(item.name)") {{$t('gzzoc.upload')}}
                                span.file-name(v-show="upload[item.name]") {{upload[item.name]}}
                        //select
                        el-select.gzzoc-select.item(
                            v-model="item.value",
                            v-else-if="item.ques_type === 'single_choice' && item.show_type === 'pull'")
                            el-option(
                                v-for="(info, i) in item.options",
                                :key='i',
                                :label="info.show_name",
                                :value="info.value")
                        //checkbox
                        el-checkbox-group.item(
                            v-model="item.value",
                            v-else-if="item.ques_type === 'multi_choice'")
                            el-checkbox.gzzoc-checkbox(
                                v-for="(info, i) in item.options",
                                :key='i',
                                :name="item.name",
                                :label="info.value") {{info.show_name}}
                        //completion
                        el-input.gzzoc-input.item(
                            type="text",
                            v-model="item.value",
                            v-else-if="item.ques_type === 'completion' && item.data_type === 'number'",
                            :placeholder="$t('gzzoc.numberPlease')")
                        //default
                        el-input.gzzoc-input(
                            type="text",
                            v-model="item.value",
                            v-else,
                            :placeholder="$t('gzzoc.contentPlease')")
        template(slot="left-footer")
            .form-footer
                el-button.gzzoc-button-primary.submit-btn(type="primary", @click="submit", :disabled="status === 'executing'") {{$t('startAnalysis')}}
                el-button.gzzoc-button-secondary.reset-btn(type="primary" @click="reset") {{$t('reset')}}
        template(slot="right-content")
            .right-content
                .main
                    .item(v-for="item in result.report")
                        .eye
                            img.eye-img(:src="imgsrc(item.img.value)")
                            .name {{item.img.name}}
                        .result.diagnose-advice
                            .title {{$t('gzzoc.predictedResults')}}
                            .detail
                                p.detail-item(v-for="it in item.res")
                                    span.item-name {{it.name}}：
                                    span.item-result {{it.remark}}
                //- .footer
                //-     .footer-item.signature
                //-         span.name {{$t('gzzoc.doctorSignature')}}：
                //-         span.sign
                //-     .footer-item
                //-         span.name {{$t('gzzoc.date')}}：
                //-         span.value {{result.date}}
</template>

<script>
import _ from 'lodash';
import { languages, i18n } from "@/locale";
import Logo from 'components/logo';
import UserNav from 'components/user-nav';
import ModelBasic from './gzzoc-model-basic';
import GroupTitle from '../components/group-title';
import UtilMixins from '@/mixins/utils';
import GzzocModelMixin from './gzzoc-model-mixin';
import ls from '@/utils/local-storage';

export default {
    data () {
        return {
            languages: languages,
            loading: {
                executing: false,
            },
            lock: [],
            download: {
                loading: false,
                locked: false
            },
            modelData: {
                parameter_list: []
            },
            model: {
                parameters: []
            },
            status: 'not_start',
            errorInfo: '',
            result: {
                value: '',
                explain: '',
                // success、error
                status: ''
            },
            upload: {
                loading_eyelid_images: false,
                status: "",
                eyelid_images: ""
            },
            date: ""
        };
    },
    mixins: [UtilMixins, GzzocModelMixin],
    components: {
        Logo,
        UserNav,
        ModelBasic,
        GroupTitle
    },
    computed: {
        id () {
            return this.$route.params.id;
        },
        lang () {
            return _.find(languages, {lang: this.$i18n.locale}) || languages[0];
        },
        titleClass () {
            let cls = ls.get('lang');
            return {
                'cn': cls === 'zh-CN',
                'en': cls === 'en'
            };
        },
        showForm () {
            return _.get(this.model, 'parameters', []).length > 0;
        },
        rules () {
            return {
                camera_brand: [
                    {
                        required: true,
                        trigger: ['change'],
                        message: i18n.t('message.cameraBrand')
                    }
                ],
                camera_model: [
                    {
                        required: true,
                        trigger: ['change'],
                        message: i18n.t('message.cameraModel')
                    }
                ],
                quality_type: [
                    {
                        required: true,
                        trigger: ['change'],
                        message: i18n.t('message.qualityType')
                    }
                ],
            };
        }
    },
    mounted () {
        this.getData();
    },
    destroyed () {
        clearTimeout(this.timer)
    },
    methods: {
        loadingUploadBtn (key) {
            return this.upload["loading_" + key];
        },
        reset () {
            _.forEach(_.get(this, 'model.parameters', []), model => {
                switch (model.ques_type) {
                    case "single_choice": {
                        this.$set(model, 'value', model.default_value);
                        break;
                    }
                    case "multi_choice": {
                        this.$set(model, 'value', model.default_value);
                        break;
                    }
                    default: {
                        this.$set(model, 'value', '');
                        break;
                    }
                }
                this.upload.eyelid_images = "";
            });
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
        },
        beforeImgUpload (file) {
            const types = ['image/jpeg', 'image/png', 'image/jpg'];
            const size = 5;

            const isJPG = (_.indexOf(types, file.type) > -1);
            const isLt2M = file.size / 1024 / 1024 < size;

            if (!isJPG) {
                this.$message.error(i18n.t('message.imgTypeUnknown'));
            } else if (!isLt2M) {
                this.$message.error(i18n.t('message.imgSizeExceed', { size }));
            }
            return isJPG && isLt2M;
        },
        uploadsucc (res, file, files, key) {
            const id = _.get(file, 'response.value[0]._id');
            const paramList = this.model.parameters;
            this.upload['loading_' + key] = false;
            if (id) {
                const i = _.findIndex(paramList, ['name', key]);
                paramList[i].value = [{
                    name:file.name,
                    value:id
                }];
                this.upload[key] = file.name;
                this.upload.status = 'success';
                this.$message.success(i18n.t('message.imgUploadSuccess'));

            } else {
                this.upload.status = 'error';
                this.$message.error(i18n.t('message.imgUploadFail'));
            }
        },
        handleProgress (key) {
            this.upload.status = 'progress';
            this.upload['loading_' + key] = true;
        },
        handleError (res, key) {
            const errorInfo = JSON.parse(res.toString().replace('Error: ', ''));
            const errorMessage = _.get(errorInfo, '_error.detail', '');

            if (errorMessage) {
                this.$message.error(errorMessage);
            }

            this.upload.status = 'error';
            this.upload['loading_' + key] = false;
        },
        submit () {
            this.$refs.form.validate(result => {
                if (!result) {
                    this.$message.error(this.$t('pleaseCheckInput'));
                    return;
                } else if (this.upload.eyelid_images === "") {
                    this.$message.error(i18n.t('message.imgAtLeastOne'));
                    return;
                }
                this.status = 'executing';
                let parameters = this.getParameterValue();
                this.$http.post('mli/predict_model/create_task', {
                    model_id: this.id,
                    parameters
                }).then(resp => {
                    if (_.get(resp, 'body.value.code') !== 0) {
                        let errorInfo = _.get(resp, 'body.value.error');
                        this.status = 'failed';
                        this.$message.error(errorInfo);
                        this.errorInfo = errorInfo;
                        return;
                    }
                    this.task_id = _.get(resp, 'body.value.data.task_id');
                    this.getResult(this.task_id);
                });
            });
        },
        async getData () {
            this.model.parameters = [];
            await this.$http.get('mli/predict_model/model', {
                params: {
                    model_id: this.id
                }
            }).then(resp => {
                this.modelData = _.get(resp, 'body.value.data');
                this.model.parameters = this.formatParameters(this.modelData.parameters);
                this.reset();
            });
        },
        getResult (taskId) {
            if (!taskId) {
                this.status = 'not_start';
                return;
            }
            clearTimeout(this.timer);
            this.$http.get('/api/mli/predict_model/task_result', {
                params: {
                    task_id: Array.isArray(taskId) ? taskId.join('|') : taskId
                }
            }).then(resp => {
                if (_.get(resp, 'body.value.code') !== 0) {
                    let errorInfo = _.get(resp, 'body.value.error');
                    this.status = 'failed';
                    this.$message.error(errorInfo);
                    this.errorInfo = errorInfo;
                    return;
                }
                const status = _.get(resp, 'body.value.data.status');
                if (status === 'failed') {
                    let errorInfo = _.get(resp, 'body.value.data.error_info[0]', this.$t('gzzoc.execFailed'));
                    this.status = 'failed';
                    this.$message.error(errorInfo);
                    this.errorInfo = errorInfo;
                    return;
                } else if (status === 'completed') {
                    const result = _.get(resp, 'body.value.data.results', {});
                    if (result.report[0].img === null) {
                        let errorInfo = _.get(resp, 'body.value.data.error_info[0]', this.$t('gzzoc.execFailed'));
                        this.status = 'failed';
                        this.$message.error(errorInfo);
                        this.errorInfo = errorInfo;
                    } else {
                        // 质量分析结果 排序 - 显示质量分析结果与质量分析类别排序一致 （由于后端不方便处理，有前端处理）
                        const qualityTypeList = _.map(this.modelData.parameters.quality_type[0].options, item=> item.value)
                        _.forEach(result.report, item=>{
                            const res = []
                            _.forEach(qualityTypeList, type=>{
                                const index = _.findIndex(item.res, { qa_type: type })
                                if(index >= 0){
                                    res.push(item.res[index])
                                }
                            })
                            item.res = res
                        })
                        this.result = result;
                        this.date = result.date;
                        this.status = 'success';
                    }
                    return;
                }
                this.timer = setTimeout(() => {
                    this.getResult(taskId);
                }, 3000);
            });
        },
        toDownloadPdf () {
            let taskId = Array.isArray(this.task_id) ? this.task_id.join('|') : this.task_id;
            this.downloadPdf(taskId, "dprint", this.date, this.download);
        }
    }
};
</script>

<style lang="sass" scoped>
    .form-title
        width: 100%
        height: 48px
        margin-top: 24px
        background-repeat: no-repeat
        &.cn
            background-image: url(~public/images/gzzoc/fundus-img-quality-cn.svg)
        &.en
            background-image: url(~public/images/gzzoc/fundus-img-quality-en.svg)

    .form-container
        padding: 20px
        overflow: auto
        flex: 1 1 auto
        width: 400px
        .name
            line-height: 1.4
            font-family: PingFangSC-Regular
            font-size: 14px
            color: #666
            margin-bottom: 10px
            white-space: nowrap
        .file-content-wrapper
            display: flex
            align-items: center
            margin-top: 10px
            width: 100%
            .upload-button
                flex: 0 0
                margin-top: 0
            .file-name
                flex: 1 1
                margin-left: 16px
                font-size: 14px
                color: #999
                overflow: hidden
                text-overflow: ellipsis
                white-space: nowrap
                text-align: left
    .form-footer
        padding: 20px 20px
        text-align: center
        height: 90px
        .submit-btn
            width: 232px
            height: 40px
        .reset-btn
            width: 104px
            height: 40px
            margin-left: 16px

    .right-content
        .main
            display: flex
            .item
                flex: 1 1 !important
                &:not(:first-child)
                    margin-left: 24px
                .eye
                    width: 300px
                    position: relative
                    left: 50%
                    transform: translateX(-50%)
                    margin-top: 24px
                    .eye-img
                        width: 300px
                        height: 300px
                        background-color: #fff
                        object-fit: scale-down
                    .name
                        font-family: PingFangSC-Regular
                        font-size: 14px
                        color: #333
                        text-align: center
                        margin-top: 16px
                .result
                    padding: 16px 0
                    &:not(:last-child)
                        border-bottom: 1px solid #999
                    .title
                        font-family: PingFangSC-Semibold
                        font-size: 20px
                        font-weight: bold
                        color: #333
                        line-height: 30px
                    .detail
                        .detail-item
                            line-height: 20px
                            vertical-align: top
                            margin-top: 8px
                            margin-right: 2%
                            .item-name
                                font-family: PingFangSC-Regular
                                font-size: 14px
                                color: #666
                            .item-result
                                font-family: PingFangSC-Regular
                                font-size: 14px
                                color: #333
        .footer
            .footer-item
                width: 230px
                position: relative
                left: 100%
                transform: translateX(-100%)
                &:not(:first-child)
                    margin-top: 8px
                .name
                    font-family: PingFangSC-Regular
                    font-size: 14px
                    color: #666
                    line-height: 20px
                    display: inline-block
                    height: 20px
                .value
                    font-family: PingFangSC-Regular
                    font-size: 14px
                    color: #333
                    line-height: 20px
                    display: inline-block
                    height: 20px
            .signature
                .sign
                    display: inline-block
                    width: 154px
                    height: 28px
                    background: url(~public/images/gzzoc/Visionome.png) no-repeat left top / 154px 28px
</style>
